import { Box } from '@factorialco/deprecated-design-system'
import { VerticalBarChart } from '@factorialco/f0-react'
import {
  FormElementAnalyticsDocument,
  FormInsightsOverviewElementFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ChartWidget } from 'modules/engagement_surveys/components/FormInsightsOverview/InsightsVisualization/ChartWidget'
import type { FormFiltersStorage } from 'modules/forms'

import { LoadingState } from './LoadingState'
import { mergeAnalyticsData } from './utils'

interface Props {
  element: FormInsightsOverviewElementFragment
  activeFilters?: FormFiltersStorage['filters']
  cycleIds?: number[]
}

export function Select({ element, activeFilters, cycleIds }: Props) {
  const { data, loading } = useQuery(FormElementAnalyticsDocument, {
    variables: {
      elementId: element.id,
      ...activeFilters,
      cycleIds,
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  if (loading) {
    return <LoadingState element={element} />
  }

  const allOptions = element.options.map((option) => option.label)
  const { categories, series } = data?.forms.elementAnalyticsConnection?.nodes?.[0] || {}

  const chartData = mergeAnalyticsData({
    allOptions,
    categories,
    series,
  })

  return (
    <ChartWidget
      title={element.label}
      description={element.description || ''}
      questionType={element.type}
    >
      <Box style={{ height: `${allOptions.length * 24 + 16}px` }}>
        <VerticalBarChart
          data={chartData}
          dataConfig={{
            value: {
              label: 'Value',
            },
          }}
          showRatio
          valueFormatter={(value: number) => `${value}%`}
          hideGrid
        />
      </Box>
    </ChartWidget>
  )
}
